import { PropsWithChildren, ReactNode } from 'react'
import { ToastContainer } from 'react-toastify'
import { defaultConfig } from 'config/default'
import { LanguageSwitcher, StoreBrand } from 'shared/components'

type AuthCardProps = PropsWithChildren<{
	title: string
	description?: string
	footer?: ReactNode
}>

export const AuthCard = ({ title, description, footer, children }: AuthCardProps) => (
	<section className="flex min-h-screen items-center justify-center bg-background p-4">
		<div className="w-full max-w-[400px]">
			<div className="rounded-lg border border-border bg-card p-6 shadow-panel sm:p-8">
				<div className="mb-8 flex items-center justify-between gap-3">
					<StoreBrand />
					<LanguageSwitcher variant="compact" />
				</div>
				<h1 className="font-display text-xl font-bold text-foreground">{title}</h1>
				{description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
				<div className="mt-6">{children}</div>
			</div>
			{footer && <div className="mt-5 text-center text-[13px]">{footer}</div>}
		</div>
		<ToastContainer
			position="top-right"
			autoClose={defaultConfig.redirectTimer}
			rtl={false}
			hideProgressBar
			closeOnClick={false}
		/>
	</section>
)
